<div class="padding-bottom">
    <div class="grid-container consents__optin choice-box choice-box--inline-left">
        <input
            id="acceptationConsents"
            class="choice"
            type="checkbox"
            required=""
            [appTagCommander]="'tagCo.consents.accept.checkbox'"
            [ngClass]="{ 'ng-dirty': warningAcceptationConsents }"
            [(ngModel)]="acceptationConsents"
            (change)="verifyCheckboxEade()"
        />
        <div class="choice-box__label choice-box__container">
            <span>
                <label class="choice-box__label choice-box__label--pegase" for="acceptationConsents"> </label>
                <label class="choice-box_text__label" for="acceptationConsents">{{ 'consents.declare' | i18n }}</label>
                <div *ngIf="!topSansSelectionMedicale" class="consents__other--link">
                    <a class="consents__other--link_a" target="_blank" data-tag-commander="" [appTagCommander]="'tagCo.consents.document.download.ADH3025'">
                        <em (click)="downloadConsent()" class="icon icon--download-line" style="margin-right: 2%"></em>
                        <span
                            ><span (click)="downloadConsent()"> {{ 'consents.declare.link.text.h2' | i18n }}</span></span
                        >
                    </a>
                </div>
                <div class="consents__other--link">
                    <a class="consents__other--link_a" target="_blank" [appTagCommander]="'tagCo.consents.document.download.nif'">
                        <em (click)="downloadNoticeDoc()" class="icon icon--download-line" style="margin-right: 2%"></em>
                        <span>
                            <span (click)="downloadNoticeDoc()">
                                {{ 'consents.advisor.link.fileName' | i18n }}
                            </span>
                        </span>
                    </a>
                </div>
                <div *ngIf="droitOubli && !topSansSelectionMedicale" class="consents__other--link">
                    <a class="consents__other--link_a" target="_blank" [appTagCommander]="'tagCo.consents.document.download.DOC3202'">
                        <em (click)="downloadDroitOubli()" class="icon icon--download-line" style="margin-right: 2%"></em>
                        <span>
                            <span (click)="downloadDroitOubli()">
                                {{ 'consents.aeras.link_oubli.text.h2' | i18n }}
                            </span>
                        </span>
                    </a>
                </div>
                <div *ngIf="topSansSelectionMedicale" class="consents__other--link">
                    <a class="consents__other--link_a" target="_blank" data-tag-commander="" [appTagCommander]="'tagCo.consents.document.download.nif'">
                        <em (click)="downloadConventionAeras()" class="icon icon--download-line" style="margin-right: 2%"></em>
                        <span>
                            <span (click)="downloadConventionAeras()">{{ 'consents.aeras.link_aeras.text' | i18n }}</span></span
                        >
                    </a>
                </div>
            </span>
        </div>
    </div>
    <div class="consents__download_error">
        <p *ngIf="warningDroitOUbliDownloaded && !topSansSelectionMedicale">
            {{ 'consents.download.error.forget' | i18n }}
        </p>
        <p *ngIf="warningNoticeDownloaded">
            {{ 'consents.download.error.advisor' | i18n }}
        </p>
        <p *ngIf="warningFileDownload && !topSansSelectionMedicale">
            {{ 'consents.download.error.declare' | i18n }}
        </p>
        <p *ngIf="warningConventionDownloaded && topSansSelectionMedicale">
            {{ 'convention.download.error.declare' | i18n }}
        </p>
    </div>
</div>
<div class="simulation__buttons simulation__buttons--light no-padding-left-rigth">
    <div class="grid-6 grid-mobile-2 no-gutter">
        <button type="button" class="button button--grey button--previous" data-tag-commander="" (click)="goBackToEspaceClientModal = true" [appTagCommander]="'tagCo.consents.previous.button'">
            {{ 'consents.button.prev' | i18n }}
        </button>
    </div>
    <div class="grid-6 grid-mobile-2 no-gutter">
        <div class="button button--primary button--next consents__action float-right">
            <input class="choice--buttonNeutral" type="radio" id="validationConsents" required="" value="true" data-tag-commander="" [appTagCommander]="'tagCo.consents.validate.button'" name="550" />
            <label class="consents__label" (click)="acceptConsents()" [ngClass]="{ 'icon--loading': isdownloadingDoc }">
                {{ 'consents.button.next' | i18n }}
            </label>
        </div>
    </div>
</div>
<app-validation-modal-component
    [modalTitle]="'adhesion.backToDashboard.modal.title' | i18n"
    [content]="'adhesion.backToDashboard.modal.body' | i18n"
    [visibility]="goBackToEspaceClientModal"
    (rightClick)="navigateToEspaceClient(); goBackToEspaceClientModal = !goBackToEspaceClientModal"
    (leftClick)="goBackToEspaceClientModal = false"
    (crossClick)="goBackToEspaceClientModal = false"
>
</app-validation-modal-component>
